import { useEffect, useContext } from "react";
import { Context } from "..";
import userStore from "../store/userStore";

export function usePageName(name, addition = "") {
  useEffect(() => {
    userStore.setPageName(name, addition);
  }, [name, addition]);
}
